
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proposals/[reportHash]",
      function () {
        return require("private-next-pages/proposals/[reportHash].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/proposals/[reportHash]"])
      });
    }
  